import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataConsumption } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeConsumptionAccordionProps {
  consumptionData?: EquipmentModelLatestFipeDataConsumption
}

export default function FipeConsumptionAccordion({ consumptionData }: FipeConsumptionAccordionProps) {
  return (
    <Accordion
      name="Consumption"
      head="Consumo"
      defaultOpen
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Urbano" 
            value={consumptionData?.Urbano} 
          />
          <InfoField 
            label="Rodoviário" 
            value={consumptionData?.Rodoviario} 
          />
        </div>
      }
    />
  )
}